import { BrowserRouter, Routes, Route,Outlet } from 'react-router-dom';
// import Contact from './components/Contacts/Contacts';
import Header from './components/Nav/Header';
// import Banner from './components/Banner/Banner';
import AboutMe from './pages/About/About';
// import Experience from './components/Experiences/Experiences';
import GameHub from './pages/Games/GameHub';
import PublicServicePage from './pages/Home/PublicServicePage';
import ProjectsExperience from './pages/Experiences/ProjectsExperience';
import ArticleHome from './content/articles/ui-pages/ArticleHome';
import SingleArticle from './content/articles/ui-pages/ArticleSingle';
import Footer from './components/Footer/Footer';
function MainLayout() {
  return (
    <>
      <Header />
      <Outlet />
      < Footer/>
    </>
  );
}
function App() {
  return (
    <BrowserRouter>
      <Routes>
         {/* MAIN SITE (global header ON) */}
        <Route element={<MainLayout />}>
          <Route path="/" element={<PublicServicePage />} />
          <Route path="/about" element={<AboutMe />} />
          <Route path="/experience" element={<ProjectsExperience />} />
          {/* <Route path="/contact" element={<Contact />} /> */}
          <Route path="/gamehub" element={<GameHub />} />
        </Route>
         {/* ARTICLES (global header OFF) */}
        <Route path="/article" element={<ArticleHome />} />
        <Route path="/article/:id" element={<SingleArticle />} />

      </Routes>
    </BrowserRouter>
  );
}







export default App;
